module.exports = __webpack_public_path__ + "static/media/themes-patisserie-product.png";